export default __webpack_public_path__ + "static/media/Thor-mie.494b7f50.png";